import { render, staticRenderFns } from "./BottomCom.vue?vue&type=template&id=0a5a15e0&scoped=true&"
import script from "./BottomCom.vue?vue&type=script&lang=js&"
export * from "./BottomCom.vue?vue&type=script&lang=js&"
import style0 from "./BottomCom.vue?vue&type=style&index=0&id=0a5a15e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5a15e0",
  null
  
)

export default component.exports